import React from 'react';
import ConnectedAccountInputs from '../components/AccountInputs';
import Layout from '../components/Layout';

const Account = () => (
  <Layout
    title="Let’s Get Started"
    subtitle="Review your plan and create an account."
  >
    <ConnectedAccountInputs />
  </Layout>
);

export default Account;



// WEBPACK FOOTER //
// ./src/pages/Account.jsx